export const locale = {
  lang: "tn",
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: "لوحات القيادة",
      },
      ESP: {
        COLLAPSIBLE: "Espace marchand",
      },
      Wallet: {
        SECTION: "سطوش",
        AW: {
          COLLAPSIBLE: "نشرجي حسابي",
          Carte: "عن طريق بطاقة دفع",
          Espece: "عن طريق تحويل/دفع",
          RV: "عن طريق نقطة بيع",
        },
        TA: {
          COLLAPSIBLE: "تحويل الفلوس",
          ws: "حساب صب فلوس",
          cb: "حساب بنكي",
        },
        MW: {
          COLLAPSIBLE: "Mes wallets",
        },
      },
      SERVICE: {
        SECTION: "الخدمات",
        RT: {
          COLLAPSIBLE: "شرجي تليفونك",
          TD: "حول ديركت لتلفونك",
          CR: "بطاقة شحن",
        },
        DS: {
          COLLAPSIBLE: "تسلية",
        },
        PM: {
          COLLAPSIBLE: "خلص شركائنا",
        },
        GCB: {
          COLLAPSIBLE: "إدارة الكارت",
        },
      },
      AUTRE: {
        SECTION: "****",
        FP: {
          COLLAPSIBLE: "برنامج الولاء",
        },
        MT: {
          COLLAPSIBLE: "العمليات",
        },
        MC: {
          COLLAPSIBLE: "استهلاك",
        },
        dashm: {
          COLLAPSIBLE: "لوحة تحكم التاجر",
        },
        moncompte: {
          COLLAPSIBLE: "حسابي",
        },
        trvr: {
          COLLAPSIBLE: "تحويل",
        },
        his: {
          COLLAPSIBLE: "العمليات",
        },
        conso: {
          COLLAPSIBLE: "استهلاك",
        }
      },
      DOC: {
        SECTION: "Documents",
      },
      FAQ: {
        SECTION: "الأسئلة الشائعة والاتصال",
      },
    },
  },
};
